module.exports = __webpack_public_path__ + "media/images/countrysquared/gb-763e2b271820a211b9cf49d44a003a72.svg";